module.exports = __webpack_public_path__ + "img/mrBts_test_003_BS.c1ba2b14.jpg";